import React from 'react';

import { FormContainer } from '@eika-kortbetjening/form-container';
import { LinkButton, StandardButton } from '@eika/button';

import fallbackDictionary from './fallbackDictionary';
import SelectBlockTypeForm from './select-block-type-form/SelectBlockTypeForm';
import { BlockType, Piwik, SiteCoreDictionary } from './types';

import './BlockFormBlockSelectedCard.scss';

interface FooterProps {
    next: () => void;
    cancel: () => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const Footer = ({ next, cancel, dictionary, piwik }: FooterProps) => {
    const { formNext, formCancel } = dictionary;

    return (
        <>
            <div className="footer-button-row">
                <LinkButton
                    data-track-id={piwik?.blockCardForm?.blockCardCancel?.dataTrackId}
                    data-track-linkname={piwik?.blockCardForm?.blockCardCancel?.dataTrackLinkname}
                    id={piwik?.blockCardForm?.blockCardCancel?.dataTrackId}
                    onClick={() => cancel()}
                >
                    {formCancel}
                </LinkButton>
                <StandardButton
                    data-track-id={piwik?.blockCardForm?.blockCardNext?.dataTrackId}
                    data-track-linkname={piwik?.blockCardForm?.blockCardNext?.dataTrackLinkname}
                    id={piwik?.blockCardForm?.blockCardNext?.dataTrackId}
                    onClick={() => next()}
                >
                    {formNext}
                </StandardButton>
            </div>
        </>
    );
};

interface BlockFormBlockSelectedCardProps {
    /** Selected block type */
    selectedBlockType: BlockType | undefined;
    /** Function to set selected block type */
    setSelectedBlockType: (blockType: BlockType | undefined) => void;
    /** Selected block type form error */
    selectedBlockTypeError: string | undefined;
    /** Function for the next button */
    next: () => void;
    /** Function for the cancel button */
    cancel: () => void;
    /** Include option for terminating account */
    includeTerminateAccountOption?: boolean;
    /** Sitecore dictionary */
    sitecoreDictionary?: SiteCoreDictionary;
    /** PIWIK tags */
    piwik?: Piwik;
}

const BlockFormBlockSelectedCard = ({
    selectedBlockType,
    setSelectedBlockType,
    selectedBlockTypeError,
    next,
    cancel,
    includeTerminateAccountOption = false,
    sitecoreDictionary,
    piwik,
}: BlockFormBlockSelectedCardProps): React.JSX.Element => {
    const dictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <FormContainer
            data-track-id={piwik?.blockCardForm?.blockSelectedCardForm?.dataTrackId}
            data-track-linkname={piwik?.blockCardForm?.blockSelectedCardForm?.dataTrackLinkname}
            id={piwik?.blockCardForm?.blockSelectedCardForm?.dataTrackId}
        >
            <FormContainer.Content>
                <SelectBlockTypeForm
                    selectedBlockType={selectedBlockType}
                    setSelectedBlockType={setSelectedBlockType}
                    selectedBlockTypeError={selectedBlockTypeError}
                    includeTerminateAccountOption={includeTerminateAccountOption}
                    dictionary={dictionary}
                    piwik={piwik}
                />
            </FormContainer.Content>
            <FormContainer.Footer>
                <Footer next={next} cancel={cancel} dictionary={dictionary} piwik={piwik} />
            </FormContainer.Footer>
        </FormContainer>
    );
};

export default BlockFormBlockSelectedCard;
